import React from 'react';

export const lazyImport = (importFunction: Function) => {
  return React.lazy(() => {
    if (typeof sessionStorage === 'undefined') {
      return importFunction();
    }
    return importFunction()
      .then((result: any) => {
        if (sessionStorage.getItem('chunk-reload')) {
          sessionStorage.removeItem('chunk-reload');
        }
        return result;
      })
      .catch((error: Error) => {
        const isChunkError = error?.name === 'ChunkLoadError' || /Loading chunk [\d]+ failed/i.test(error?.message);

        if (isChunkError) {
          const hasReloaded = sessionStorage.getItem('chunk-reload');

          if (!hasReloaded) {
            sessionStorage.setItem('chunk-reload', 'true');
            window.location.reload();
            return;
          }
        }

        throw error;
      });
  });
};
